// Numeric cell editor for RevoGrid. type="number" gives numeric-only entry plus
// native up/down arrow stepping, while still allowing free typing. Enter/blur saves, Esc cancels.

import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { EditorType } from '@revolist/react-datagrid';

export function NumberEditor({ save, close, ...rest }: EditorType) {
  const { t } = useTranslation('inventory-import');
  const r = rest as {
    model?: Record<string, unknown>;
    column?: { prop?: string };
    val?: unknown;
  };
  const prop = r.column?.prop;
  const initial =
    prop && r.model ? String(r.model[prop] ?? '') : String(r.val ?? '');

  // Focus on mount via ref (avoids the autoFocus attribute a11y warning).
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <input
      ref={inputRef}
      type="number"
      aria-label={t('cells.edit_value_aria')}
      defaultValue={initial}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          save((e.target as HTMLInputElement).value);
          close();
        } else if (e.key === 'Escape') {
          close();
        }
      }}
      onBlur={(e) => {
        save(e.target.value);
        close();
      }}
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        padding: '0 8px',
        boxSizing: 'border-box',
      }}
    />
  );
}
